import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** The addresses of the page «Доступы»: an answer 403 on any of them means the user is not an administrator. */
export const ACCESS_API_PREFIX = '/api/vn/adm/access';

/**
 * «Раздел только для администраторов»: the interceptor tells it when any call of the page is answered with 403, the page shows one state instead of the tabs. It is kept for the visit of
 * the app — a user who is refused is not asked again and again; it is cleared by a reload of the page.
 */
@Injectable({ providedIn: 'root' })
export class AccessForbiddenService {
  readonly changes = new BehaviorSubject<boolean>(false);

  get forbidden(): boolean {
    return this.changes.value;
  }

  mark(): void {
    if (!this.changes.value) {
      this.changes.next(true);
    }
  }
}
